import { render, staticRenderFns } from "./VehicleType.vue?vue&type=template&id=a5d0b798"
import script from "./VehicleType.vue?vue&type=script&lang=js"
export * from "./VehicleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports